import { AwsCognitoIdentity } from './AwsCognitoIdentity';
import CognitoConfigStore from '../config/cognitoConfigStore';
import { AzureIdentity } from './AzureIdentity';
import AzureConfigStore from '../config/azureConfigStore';

class IdentityManagerFactory {
  manager: any;

  constructor() {}

  getManager() {
    return this.manager;
  }

  init(data: any) {
    this.manager = data.useCognito
      ? new AwsCognitoIdentity(new CognitoConfigStore(data.cognitoConfig))
      : new AzureIdentity(new AzureConfigStore(data.azureConfig));
  }
}

let IdentityManager = new IdentityManagerFactory();

export default IdentityManager;
